import { profileIconAssetBasePath } from "icons/profile";
import { cn } from "ui";

interface ProfileTablerIconProps {
  name: string;
  className?: string;
}

export function ProfileTablerIcon(props: ProfileTablerIconProps) {
  const iconUrl = `${profileIconAssetBasePath}/${encodeURIComponent(props.name)}.svg`;

  return (
    <span
      aria-hidden
      className={cn("inline-block shrink-0 bg-current", props.className)}
      style={{
        maskImage: `url("${iconUrl}")`,
        maskPosition: "center",
        maskRepeat: "no-repeat",
        maskSize: "contain",
        WebkitMaskImage: `url("${iconUrl}")`,
        WebkitMaskPosition: "center",
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskSize: "contain",
      }}
    />
  );
}
